import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "c-bg--gray--pc c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = {
  key: 0,
  class: "p-search-suggest p-search-suggest--message"
}
const _hoisted_5 = {
  key: 0,
  class: "p-search-suggest__title"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  class: "p-search-group__name",
  "data-translate-skip": ""
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "p-search-group__users"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "p-search-suggest__user-info" }
const _hoisted_15 = {
  class: "p-search-suggest__user-name",
  "data-translate-skip": ""
}
const _hoisted_16 = {
  class: "p-search-suggest__user-employee-id",
  "data-translate-skip": ""
}
const _hoisted_17 = {
  key: 2,
  class: "p-search-suggest__title"
}
const _hoisted_18 = ["title", "onClick"]
const _hoisted_19 = { class: "p-search-suggest__user-content" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "p-search-suggest__user-info" }
const _hoisted_22 = {
  class: "p-search-suggest__user-name",
  "data-translate-skip": ""
}
const _hoisted_23 = {
  class: "p-search-suggest__user-employee-id",
  "data-translate-skip": ""
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "p-selected-users-wrapper"
}
const _hoisted_26 = { class: "p-selected-users__header" }
const _hoisted_27 = {
  key: 0,
  class: "p-selected-users__actions"
}
const _hoisted_28 = { class: "p-selected-users__count" }
const _hoisted_29 = { class: "p-selected-users" }
const _hoisted_30 = ["onClick", "title"]
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  class: "p-selected-users__name",
  "data-translate-skip": ""
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "p-modal__header" }
const _hoisted_35 = { class: "p-modal__body" }
const _hoisted_36 = { class: "p-modal__footer" }
const _hoisted_37 = { class: "p-modal__body" }
const _hoisted_38 = { class: "p-confirm-row" }
const _hoisted_39 = { class: "p-selected-users" }
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  class: "p-selected-users__name",
  "data-translate-skip": ""
}
const _hoisted_42 = { class: "p-selected-users__footer" }
const _hoisted_43 = { class: "p-confirm-row" }
const _hoisted_44 = {
  key: 0,
  class: "p-confirm-row"
}
const _hoisted_45 = { class: "p-confirm-badge" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { "data-translate-skip": "" }
const _hoisted_48 = { class: "p-confirm-point" }
const _hoisted_49 = { class: "p-confirm-label" }
const _hoisted_50 = {
  key: 1,
  class: "p-confirm-point-formula"
}
const _hoisted_51 = { class: "p-confirm-point-formula__operator" }
const _hoisted_52 = { class: "p-confirm-row" }
const _hoisted_53 = {
  class: "p-confirm-title",
  "data-translate-skip": ""
}
const _hoisted_54 = { class: "p-confirm-row" }
const _hoisted_55 = {
  class: "p-confirm-message",
  "data-translate-skip": ""
}
const _hoisted_56 = { class: "p-modal__footer" }
const _hoisted_57 = { class: "p-selected-users__footer" }
const _hoisted_58 = { class: "p-the-page-j09" }
const _hoisted_59 = { class: "p-the-page-j09__body" }
const _hoisted_60 = {
  key: 0,
  class: "p-gift-badge"
}
const _hoisted_61 = { class: "p-gift-badge__dropdown" }
const _hoisted_62 = { class: "p-gift-badge__value" }
const _hoisted_63 = ["src"]
const _hoisted_64 = { "data-translate-skip": "" }
const _hoisted_65 = {
  key: 1,
  class: "p-gift-badge__placeholder"
}
const _hoisted_66 = { class: "p-gift-badge__arrow" }
const _hoisted_67 = {
  key: 0,
  class: "p-gift-badge__menu"
}
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["src"]
const _hoisted_70 = { "data-translate-skip": "" }
const _hoisted_71 = { "data-translate-skip": "" }
const _hoisted_72 = { "data-translate-skip": "" }
const _hoisted_73 = { "data-translate-skip": "" }
const _hoisted_74 = { "data-translate-skip": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_PointNotation = _resolveComponent("PointNotation")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_FormLabel = _resolveComponent("FormLabel")!
  const _component_TheJInputScreen = _resolveComponent("TheJInputScreen")!
  const _component_TheTemplateN = _resolveComponent("TheTemplateN")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_ModalCompletedThanksPointSend = _resolveComponent("ModalCompletedThanksPointSend")!
  const _component_LoadingProcess = _resolveComponent("LoadingProcess")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createBlock(_component_TheTemplateN, {
            key: _ctx.inputScreenKey,
            heading: "",
            "indicated-item": ['search'],
            "search-placeholder": "贈る人検索",
            "search-button-color": _ctx.colorCode,
            "error-message": _ctx.searchErrorMessage,
            onSearchChange: _ctx.onSearchChange,
            onDoSearch: _ctx.searchUser,
            onShowSearchSuggest: _ctx.showSearchSuggest
          }, {
            searchSuggest: _withCtx(() => [
              (
                _ctx.searchResult &&
                _ctx.showSuggest &&
                _ctx.availableUsers.length === 0 &&
                _ctx.availableGroups.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 検索結果対象者はすべて選択済みです。 "))
                : _createCommentVNode("", true),
              (_ctx.searchResult && _ctx.showSuggest && (_ctx.availableUsers.length > 0 || _ctx.availableGroups.length > 0))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "p-search-suggest",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    (_ctx.canSelectGroup && _ctx.availableGroups.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " グループ "))
                      : _createCommentVNode("", true),
                    (_ctx.canSelectGroup)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.availableGroups, (group) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: group.groupId,
                            class: "p-search-group"
                          }, [
                            _createElementVNode("button", {
                              class: "p-search-group__header",
                              onClick: _withModifiers(($event: any) => (_ctx.toggleGroup(group.groupId)), ["stop"])
                            }, [
                              _createElementVNode("div", {
                                class: "p-search-group__left",
                                title: `コード：${group.groupCode}`
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.expandedGroups[group.groupId] ? "▼" : "▶"), 1),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(group.groupName), 1),
                                _createElementVNode("span", null, " （" + _toDisplayString(group.userCount) + "） ", 1)
                              ], 8, _hoisted_7),
                              (_ctx.isSp)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "p-search-suggest__info",
                                    onClick: _withModifiers(($event: any) => (_ctx.showGroupInfo(group)), ["stop"])
                                  }, " ⓘ ", 8, _hoisted_9))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_6),
                            (_ctx.expandedGroups[group.groupId])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createElementVNode("button", {
                                    class: "p-search-group__select-all",
                                    onClick: _withModifiers(($event: any) => (_ctx.selectGroup(group)), ["stop"])
                                  }, " このグループ所属全員を選択 ", 8, _hoisted_11),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGroupUsers(group.groupId), (user) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: user.userId,
                                      class: "p-search-group__user",
                                      onClick: _withModifiers(($event: any) => (_ctx.selectUser(user)), ["stop"])
                                    }, [
                                      (user.userImage)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: user.userImage,
                                            class: "p-search-suggest__avatar",
                                            alt: ""
                                          }, null, 8, _hoisted_13))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, _toDisplayString(user.userName), 1),
                                        _createElementVNode("div", _hoisted_16, _toDisplayString(user.usingEmployeeId) + "　" + _toDisplayString(user.groupName), 1)
                                      ])
                                    ], 8, _hoisted_12))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      : _createCommentVNode("", true),
                    (_ctx.availableUsers.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 贈る人 "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableUsers, (user) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: user.userId,
                        title: `グループ：${user.groupName}（${user.groupCode}）`,
                        class: "p-search-suggest__user",
                        onClick: _withModifiers(($event: any) => (_ctx.selectUser(user)), ["stop"])
                      }, [
                        _createElementVNode("div", _hoisted_19, [
                          (user.userImage)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: user.userImage,
                                class: "p-search-suggest__avatar",
                                alt: ""
                              }, null, 8, _hoisted_20))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, _toDisplayString(user.userName), 1),
                            _createElementVNode("div", _hoisted_23, _toDisplayString(user.usingEmployeeId) + "　" + _toDisplayString(user.groupName), 1)
                          ]),
                          (_ctx.isSp)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "p-search-suggest__info",
                                onClick: _withModifiers(($event: any) => (_ctx.showUserInfo(user)), ["stop"])
                              }, " ⓘ ", 8, _hoisted_24))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_18))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            beforeSearch: _withCtx(() => [
              (_ctx.selectedUsers.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "p-the-j-input-screen__label" }, " 贈る人 ", -1)),
                      (_ctx.selectedUsers.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.selectedUsers.length) + "/" + _toDisplayString(_ctx.maxSelectableUsers) + "名 ", 1),
                            _createElementVNode("button", {
                              class: "p-selected-users__clear",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedUsers && _ctx.clearSelectedUsers(...args)))
                            }, " すべて解除 ")
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayUsers, (user) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: user.userId,
                          class: "p-selected-users__chip",
                          onClick: _withModifiers(($event: any) => (_ctx.showUserInfo(user)), ["stop"]),
                          title: `ID：${user.usingEmployeeId}
グループ：${user.groupName}（${user.groupCode}）`
                        }, [
                          (!_ctx.isDefaultUserImage(user.userImage))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: user.userImage,
                                class: "p-selected-users__avatar-image",
                                alt: ""
                              }, null, 8, _hoisted_31))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "p-selected-users__avatar",
                                style: _normalizeStyle({backgroundColor: _ctx.getGroupColor(user.groupName)}),
                                "data-translate-skip": ""
                              }, _toDisplayString(user.groupName?.trim().split(/[\s　]+/).slice(0, 2).map(word => word.charAt(0)).join("") || "?"), 5)),
                          _createElementVNode("span", _hoisted_32, _toDisplayString(user.userName), 1),
                          _createElementVNode("button", {
                            class: "p-selected-users__remove",
                            onClick: _withModifiers(($event: any) => (_ctx.removeUser(user.userId)), ["stop"])
                          }, " × ", 8, _hoisted_33)
                        ], 8, _hoisted_30))
                      }), 128)),
                      (_ctx.showModal)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "p-modal-overlay",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModal = false))
                          }, [
                            _createElementVNode("div", {
                              class: "p-modal",
                              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.modalTitle), 1),
                              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.modalMessage), 1),
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("button", {
                                  class: "p-modal__button",
                                  style: _normalizeStyle({ background: _ctx.colorCode }),
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal = false))
                                }, " OK ", 4)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showConfirmModal)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "p-modal-overlay",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showConfirmModal = false))
                          }, [
                            _createElementVNode("div", {
                              class: "p-confirm-modal",
                              onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _cache[33] || (_cache[33] = _createElementVNode("div", { class: "p-modal__header" }, " 入力内容確認 ", -1)),
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "p-confirm-label" }, " 贈る人 ", -1)),
                                  _createElementVNode("div", _hoisted_39, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.confirmDisplayUsers, (user) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: user.userId,
                                        class: "p-selected-users__chip"
                                      }, [
                                        (!_ctx.isDefaultUserImage(user.userImage))
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: user.userImage,
                                              class: "p-selected-users__avatar-image",
                                              alt: ""
                                            }, null, 8, _hoisted_40))
                                          : (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              class: "p-selected-users__avatar",
                                              style: _normalizeStyle({backgroundColor: _ctx.getGroupColor(user.groupName)}),
                                              "data-translate-skip": ""
                                            }, _toDisplayString(user.groupName?.trim().split(/[\s　]+/).slice(0, 2).map(word => word.charAt(0)).join("") || "?"), 5)),
                                        _createElementVNode("span", _hoisted_41, _toDisplayString(user.userName), 1)
                                      ]))
                                    }), 128))
                                  ]),
                                  _createElementVNode("div", _hoisted_42, [
                                    (!_ctx.confirmShowAllUsers && _ctx.confirmHiddenUserCount > 0)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "p-selected-users__toggle",
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmShowAllUsers = true))
                                        }, " + " + _toDisplayString(_ctx.confirmHiddenUserCount) + "名 ", 1))
                                      : _createCommentVNode("", true),
                                    (_ctx.confirmShowAllUsers && _ctx.selectedUsers.length > 9)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "p-selected-users__toggle",
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmShowAllUsers = false))
                                        }, " 閉じる "))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                  (_ctx.selectedGiftBadge)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "p-confirm-label" }, " バッジ ", -1)),
                                        _createElementVNode("div", _hoisted_45, [
                                          _createElementVNode("img", {
                                            src: _ctx.selectedGiftBadge.icon,
                                            class: "p-confirm-badge__icon",
                                            alt: ""
                                          }, null, 8, _hoisted_46),
                                          _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.selectedGiftBadge.name), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.selectedUsers.length > 1
                                ? "合計送付ポイント"
                                : "送付ポイント"), 1),
                                    (_ctx.selectedUsers.length === 1)
                                      ? (_openBlock(), _createBlock(_component_PointNotation, {
                                          key: 0,
                                          "font-size": 24,
                                          point: _ctx.confirmData.sendPoint,
                                          "sign-is-exists": false
                                        }, null, 8, ["point"]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                          _createVNode(_component_PointNotation, {
                                            "font-size": 24,
                                            point: _ctx.confirmData.sendPoint,
                                            "sign-is-exists": false
                                          }, null, 8, ["point"]),
                                          _createElementVNode("span", _hoisted_51, [
                                            _createTextVNode(" × " + _toDisplayString(_ctx.selectedUsers.length) + " ", 1),
                                            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "p-confirm-point-formula__unit" }, "名", -1))
                                          ]),
                                          _cache[30] || (_cache[30] = _createElementVNode("span", { class: "p-confirm-point-formula__operator" }, " = ", -1)),
                                          _createVNode(_component_PointNotation, {
                                            "font-size": 24,
                                            point: _ctx.usedPoints,
                                            "sign-is-exists": false
                                          }, null, 8, ["point"])
                                        ]))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "p-confirm-label" }, " タイトル ", -1)),
                                  _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.confirmData.title), 1)
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "p-confirm-label" }, " 本文 ", -1)),
                                  _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.confirmData.message), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("button", {
                                  class: "p-confirm-cancel",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showConfirmModal = false))
                                }, " 戻る "),
                                _createElementVNode("button", {
                                  class: "p-modal__button",
                                  style: _normalizeStyle({ background: _ctx.colorCode }),
                                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.sendThanksPoint && _ctx.sendThanksPoint(...args)))
                                }, " 上記内容で贈る ", 4)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      (!_ctx.showAllUsers && _ctx.hiddenUserCount > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "p-selected-users__toggle",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showAllUsers = true))
                          }, " + " + _toDisplayString(_ctx.hiddenUserCount) + "名 ", 1))
                        : _createCommentVNode("", true),
                      (_ctx.showAllUsers && _ctx.selectedUsers.length > 9)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "p-selected-users__toggle",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showAllUsers = false))
                          }, " 閉じる "))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            header: _withCtx(() => [
              _createVNode(_component_CommonHeading, null, {
                default: _withCtx(() => _cache[34] || (_cache[34] = [
                  _createTextVNode("贈与内容入力", -1)
                ])),
                _: 1,
                __: [34]
              })
            ]),
            contents: _withCtx(() => [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  (_ctx.showGiftBadge)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createVNode(_component_FormLabel, {
                          for: "badge",
                          required: _ctx.giftBadgeRequired
                        }, {
                          default: _withCtx(() => _cache[35] || (_cache[35] = [
                            _createTextVNode("バッジ", -1)
                          ])),
                          _: 1,
                          __: [35]
                        }, 8, ["required"]),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "p-gift-badge__selected",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isBadgeDropdownOpen = !_ctx.isBadgeDropdownOpen))
                          }, [
                            _createElementVNode("div", _hoisted_62, [
                              (_ctx.selectedGiftBadge)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("img", {
                                      src: _ctx.selectedGiftBadge.icon,
                                      class: "p-gift-badge__icon",
                                      alt: ""
                                    }, null, 8, _hoisted_63),
                                    _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.selectedGiftBadge.name), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(_ctx.noSelectBadge), 1))
                            ]),
                            _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.isBadgeDropdownOpen ? "▲" : "▼"), 1)
                          ]),
                          (_ctx.isBadgeDropdownOpen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "p-gift-badge__option",
                                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.clearGiftBadge && _ctx.clearGiftBadge(...args)))
                                }, _cache[36] || (_cache[36] = [
                                  _createElementVNode("span", { class: "p-gift-badge__placeholder" }, "未設定", -1)
                                ])),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.giftBadges, (badge) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: badge.id,
                                    type: "button",
                                    class: "p-gift-badge__option",
                                    onClick: ($event: any) => (_ctx.selectGiftBadge(badge))
                                  }, [
                                    _createElementVNode("img", {
                                      src: badge.icon,
                                      class: "p-gift-badge__icon",
                                      alt: ""
                                    }, null, 8, _hoisted_69),
                                    _createElementVNode("span", _hoisted_70, _toDisplayString(badge.name), 1)
                                  ], 8, _hoisted_68))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", {
                          class: "p-search-help-wrapper",
                          onMouseenter: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.showBadgeTooltipPc && _ctx.showBadgeTooltipPc(...args))),
                          onMouseleave: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.hideBadgeTooltipPc && _ctx.hideBadgeTooltipPc(...args)))
                        }, [
                          _createElementVNode("div", {
                            class: "p-search-help",
                            onClick: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleBadgeTooltip && _ctx.toggleBadgeTooltip(...args)), ["stop"]))
                          }, " ⓘ "),
                          (_ctx.showBadgeTooltip && !_ctx.isSp)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "p-search-help__tooltip",
                                onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                              }, _cache[37] || (_cache[37] = [
                                _createTextVNode(" 贈りたい内容に合ったバッジを選択できます。", -1),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" ※バッジに設定された内容が自動入力されます。入力済みの内容は上書きされません。 ", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ], 32),
                        (_ctx.showBadgeTooltip && _ctx.isSp)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "p-help-modal-overlay",
                              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showBadgeTooltip = false))
                            }, [
                              _createElementVNode("div", {
                                class: "p-help-modal",
                                onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
                              }, _cache[38] || (_cache[38] = [
                                _createElementVNode("div", { class: "p-help-modal__body" }, [
                                  _createTextVNode(" 贈りたい内容に合ったバッジを選択できます。"),
                                  _createElementVNode("br"),
                                  _createTextVNode(" ※バッジに設定された内容が自動入力されます。入力済みの内容は上書きされません。 ")
                                ], -1)
                              ]))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(), _createBlock(_component_TheJInputScreen, {
                    ref: "inputScreen",
                    key: _ctx.inputScreenKey,
                    "available-points": _ctx.availablePoints,
                    "points-to-send": _ctx.pointsToSend,
                    "max-points": _ctx.maxPoints,
                    "min-points": _ctx.minPoints,
                    "giving-type": _ctx.thanksMessageType,
                    "default-message": _ctx.defaultMessage,
                    "fixed-point": _ctx.fixedPoint,
                    "used-points": _ctx.usedPoints,
                    "selected-user-count": _ctx.selectedUsers.length,
                    "gift-badge-required": _ctx.giftBadgeRequired,
                    "selected-gift-badge-id": _ctx.selectedGiftBadgeId,
                    "title-edit-enabled": _ctx.titleEditEnabled,
                    onSendPointChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sendPoint = $event)),
                    onShowConfirm: _ctx.openConfirmModal
                  }, null, 8, ["available-points", "points-to-send", "max-points", "min-points", "giving-type", "default-message", "fixed-point", "used-points", "selected-user-count", "gift-badge-required", "selected-gift-badge-id", "title-edit-enabled", "onShowConfirm"]))
                ])
              ])
            ]),
            _: 1
          }, 8, ["search-button-color", "error-message", "onSearchChange", "onDoSearch", "onShowSearchSuggest"]))
        ])
      ]),
      _createVNode(_component_TheFooter),
      (_ctx.selectedGroupInfo)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "p-user-info-modal-overlay",
            onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.selectedGroupInfo = null), ["stop"]))
          }, [
            _createElementVNode("div", {
              class: "p-user-info-modal",
              onClick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_71, "コード：" + _toDisplayString(_ctx.selectedGroupInfo.groupCode), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedUserInfo)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "p-user-info-modal-overlay",
            onClick: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeUserInfo && _ctx.closeUserInfo(...args)), ["stop"]))
          }, [
            _createElementVNode("div", {
              class: "p-user-info-modal",
              onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", null, [
                _cache[39] || (_cache[39] = _createTextVNode("ID：", -1)),
                _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.selectedUserInfo.usingEmployeeId), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[40] || (_cache[40] = _createTextVNode("グループ：", -1)),
                _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.selectedUserInfo.groupName) + "（" + _toDisplayString(_ctx.selectedUserInfo.groupCode) + "）", 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.completedModalType === 1)
        ? (_openBlock(), _createBlock(_component_ModalCompletedThanksPointSend, {
            key: 2,
            "modal-complete-data": _ctx.completedModalData,
            heading: '承認依頼しました',
            onClose: _ctx.closeCompletedModal
          }, {
            text: _withCtx(() => [
              _cache[41] || (_cache[41] = _createTextVNode(" 現在、", -1)),
              _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.thanksPointName), 1),
              _cache[42] || (_cache[42] = _createTextVNode("は承認待ちです。 ", -1))
            ]),
            _: 1
          }, 8, ["modal-complete-data", "onClose"]))
        : (_ctx.completedModalType === 2)
          ? (_openBlock(), _createBlock(_component_ModalCompletedThanksPointSend, {
              key: 3,
              "modal-complete-data": _ctx.completedModalData,
              heading: _ctx.thanksPointName + 'を送付しました',
              onClose: _ctx.closeCompletedModal
            }, {
              text: _withCtx(() => _cache[43] || (_cache[43] = [
                _createTextVNode(" 送付内容はポイント確認ページからご確認いただけます。 ", -1)
              ])),
              _: 1
            }, 8, ["modal-complete-data", "heading", "onClose"]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_LoadingProcess)
  ], 64))
}